import { LoadingContainer, LegacyPage, Model } from 'peach/components'
import { useParams, useRouteMatch, useHistory } from 'peach/router'
import { useClickAction } from 'peach/decorators/withActionTrigger'

import { useCompanyAppDomainGetAll } from 'core/types'

const AppDomains = () => {
  const { companyId } = useParams<{ companyId?: string }>()
  const { url } = useRouteMatch()
  const history = useHistory()

  const { data: appDomains, isLoading } = useCompanyAppDomainGetAll({
    companyId,
  })

  useClickAction({
    label: 'Create App Domain',
    onClick: () => history.push(`${url}/create`),
  })

  return (
    <LoadingContainer isLoading={isLoading}>
      <LegacyPage.Full>
        <Model.List
          json={appDomains}
          title='App Domains'
          withDetails
          withRelated
          withTimestamps
        />
      </LegacyPage.Full>
    </LoadingContainer>
  )
}

export default AppDomains
